import hateoas from 'viralstyle-ui/src/hateoas';
import storage from 'viralstyle-ui/src/storage';
import get from 'lodash/get';

import config from 'config';
import keenIO from '../../../utils/keen-io';
import dataCollection from '../../data-collection/_index';
import { UpsellModel } from './models';

const jwtSuffix = config.ENVIRONMENT === 'Production' ? '' : '-dev';

export const getUpsells = async ({ state, dispatch, commit }, lookupNumber) => {
  let response,
    upsellsSeen = storage.get(`${lookupNumber}-upsells-seen`) || [];

  commit('updateState', { object: state, property: 'showUpsellModal', value: false });
  commit('lockScroll', false);

  try {
    let url = hateoas.url('get_next_upsell', { lookupNumber });

    if (upsellsSeen.length) url += `?used_ids[]=${upsellsSeen.join('&used_ids[]=')}`;

    response = await dispatch('get', url);

    upsellsSeen.push(response.data.id);

    if (!dataCollection.isBot) {
      keenIO.upsell(response.data.campaign.analytics_cid, response.data.campaign.design_id, response.data.trigger_cid);
    }

    commit('updateState', { object: state, property: 'currentUpsell', value: response.data });
    commit('updateState', { object: state, property: 'showUpsellModal', value: true });
    commit('lockScroll', true);

  } catch (e) {
    commit('updateState', { object: state, property: 'currentUpsell', value: new UpsellModel() });
    commit('lockScroll', false);

    response = Promise.resolve();
  }

  if (upsellsSeen.length) storage.set(`${lookupNumber}-upsells-seen`, upsellsSeen);

  return response;
};

export const addUpsell = async ({ dispatch, commit, state }, payload) => {
  commit('updateState', { object: state, property: 'showUpsellModal', value: false });
  commit('lockScroll', false);

  let response = await dispatch('put', { apiUrl: state.currentUpsell._links.credit_card_convert.href, payload });

  response = await dispatch('getOrderGroup', storage.get('order-group-url'));

  return response;
};

export const initializePaypalUpsell = ({ rootState, state, dispatch }, { size, colorId, quantity, productId }) => {
  let returnUrl = `https://${window.location.host}/purchase/paypal-upsell`,
    callbackUrls = [],
    orderGroup = rootState.orderSummary.orderGroup;

  callbackUrls.push(`callback_urls[success]=${encodeURIComponent(returnUrl)}?upsell=${size},${quantity},${colorId},${encodeURIComponent(state.currentUpsell._links.convert_paypal.href)},${productId}`);
  callbackUrls.push(`callback_urls[cancel]=${encodeURIComponent(returnUrl)}`);
  callbackUrls.push(`customer_name=${encodeURIComponent(orderGroup.customer.name)}`);
  callbackUrls.push(`street_1=${encodeURIComponent(orderGroup.customer.address.street_1)}`);
  callbackUrls.push(`city=${encodeURIComponent(orderGroup.customer.address.city)}`);
  callbackUrls.push(`province=${encodeURIComponent(orderGroup.customer.address.province)}`);
  callbackUrls.push(`zip=${encodeURIComponent(orderGroup.customer.address.zip)}`);
  callbackUrls.push(`country=${encodeURIComponent(orderGroup.customer.address.country)}`);
  callbackUrls.push(`size=${encodeURIComponent(size)}`);
  callbackUrls.push(`color_id=${encodeURIComponent(colorId)}`);
  callbackUrls.push(`quantity=${encodeURIComponent(quantity)}`);
  callbackUrls.push(`product_id=${encodeURIComponent(productId)}`)
  if (orderGroup.customer.address.street_2) callbackUrls.push(`street_2=${encodeURIComponent(orderGroup.customer.address.street_2)}`);
  if (orderGroup.customer.phone) callbackUrls.push(`phone=${encodeURIComponent(orderGroup.customer.phone)}`);

  return dispatch('get', `${state.currentUpsell._links.initialize_paypal.href}?${callbackUrls.join('&')}`);
};

export const checkoutPaypalUpsell = async ({ state, dispatch, commit }, data) => {
  commit('updateState', { object: state, property: 'showUpsellModal', value: false });
  commit('lockScroll', false);

  let apiUrl = data.url || state.currentUpsell._links.convert_paypal.href,
    response = await dispatch('post', {
      apiUrl,
      payload: {
        PayerID: data.payerID,
        token: data.paymentToken,
        paymentId: data.paymentID,
        size: data.size,
        quantity: data.quantity,
        color_id: data.colorId,
        product_id: data.productId,
      },
    });

  response = await dispatch('getOrderGroup', storage.get('order-group-url'));

  dispatch('eventCompleteOrderUpsell');

  return response
};

export const linkOrder = async ({ rootState, dispatch, commit }, password) => {
  let response = await dispatch('post', { apiUrl: rootState.orderSummary.orderGroup._links.link_order, payload: { password } });

  dispatch('getUserInfo');

  return response;
};

export const quickRegister = async ({ rootState, dispatch, commit }, { password, token }) => {
  let payload = { password };

  if (token) payload.token = token;

  let response = await dispatch('post', { apiUrl: rootState.orderSummary.orderGroup._links.quick_register, payload });

  storage.setDomainCookie(`client-jwt${jwtSuffix}`, response.data.jwt, config.APP_DOMAIN);

  dispatch('getUserInfo');

  return response;
};

export const patchPhoneNumber = async ({ rootState, dispatch }, { phone_number, token }) => {
  let payload = { phone_number };

  if (token) payload.token = token;

  let response = await dispatch('patch', { apiUrl: rootState.orderSummary.orderGroup._links.update_phone_number, payload });

  dispatch('getOrderGroup', response.order);

  return response;
};